import { Injectable } from '@angular/core';
import { Page } from '@app/app/shared/models/page';
import { ObservableResult } from '@app/app/shared/store';
import { RegistrationDecision, RegistrationDecisionResult, RegistrationRequest, RegistrationsQuery } from './registration.model';
import { RegistrationsDataService } from './registrations-data.service';

@Injectable()
export class MockRegistrationsDataService implements RegistrationsDataService {
  list(query: RegistrationsQuery): ObservableResult<Page<RegistrationRequest>> {
    return ObservableResult.ofSuccess({ content: [], totalNumberOfElement: 0, pageSize: query.size, currentPageNumber: query.page });
  }

  decide(enrolmentUids: string[], decision: RegistrationDecision): ObservableResult<RegistrationDecisionResult[]> {
    return ObservableResult.ofSuccess(
      enrolmentUids.map((enrolmentUid) => ({ enrolmentUid, status: decision === 'APPROVE' ? 'ENROLLED' : 'REJECTED' })),
    );
  }
}
